<template>
  <div>
    <div style="width:60%">
      <!-- Modal -->
      <div
        id="exampleModal"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        style="width:100%"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="px-0 modal-header">
                <h5 id="exampleModalLabel" class="modal-title">
                  Modal title
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class>
                  <div class="tag-badge custom-tag-badge">
                    <span class="dot custom-dot text-center pl-1">
                      <i
                        class="orange-icon orange-icon-badge-align fas fa-edit"
                      />
                    </span>
                    <span class="tag-badge-title py-1 pl-2 at-badge">
                      Evaluación AT
                    </span>
                  </div>
                  <ValidationObserver
                    ref="formValidator"
                    v-slot="{ invalid, handleSubmit }"
                  >
                    <form
                      id="modal-cambiar-form"
                      ref="form"
                      class="needs-validation"
                      novalidate
                      @submit.prevent="handleSubmit"
                    >
                      <div class="form-group mb-4 section-2-wrapper">
                        <div class="section-2-sub-section-wrapper">
                          <span>
                            ¿Es necesario realizar evaluación para la solicitud
                            de asistencia tecnológica?
                          </span>
                          <div class="d-flex radio-area mt-2">
                            <ValidationProvider
                              ref="radioValidationProvider"
                              v-slot="{ errors }"
                              name="yes-or-not-answer"
                              :rules="`${!isCheckSelected ? 'required' : ''}`"
                            >
                              <div
                                class="custom-control custom-radio rbcontaineryes"
                              >
                                <input
                                  id="need-at-yes"
                                  ref="check1"
                                  v-model="
                                    preEvaluationAnswer.isAtEvaluationNeeded
                                  "
                                  :checked="
                                    preEvaluationAnswer.isAtEvaluationNeeded
                                  "
                                  name="need-at"
                                  type="radio"
                                  class="custom-control-input"
                                  :value="true"
                                  @change="resetDll"
                                />
                                <label
                                  class="custom-control-label"
                                  for="need-at-yes"
                                >
                                  Si
                                </label>
                              </div>
                              <div
                                class="custom-control custom-radio rbcontainerno"
                              >
                                <input
                                  id="need-at-no"
                                  ref="check2"
                                  v-model="
                                    preEvaluationAnswer.isAtEvaluationNeeded
                                  "
                                  :checked="
                                    !preEvaluationAnswer.isAtEvaluationNeeded
                                  "
                                  name="need-at"
                                  type="radio"
                                  class="custom-control-input"
                                  :value="false"
                                />
                                <label
                                  class="custom-control-label"
                                  for="need-at-no"
                                >
                                  No
                                </label>
                              </div>
                              <br />
                              <span
                                v-show="invalid && validationTriggered"
                                class="invalid"
                              >
                                {{ errors[0] }}
                              </span>
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                      <div class="modal-info bg-heavy-gray">
                        <div class="row no-modal-margin">
                          <div class="col-1 pt-1">
                            <i class="far fa-exclamation-circle" />
                          </div>
                          <div class="col-11 align no-padding">
                            <label>
                              Si = implica que el estudiante debe ser evaluado
                              para recomendación de Equipo en Asistencia
                              Tecnológica.
                            </label>
                          </div>
                        </div>
                        <div class="row mt-2 no-modal-margin">
                          <div class="col-1 pt-1">
                            <i class="far fa-exclamation-circle" />
                          </div>
                          <div class="col-11 align no-padding">
                            <label>
                              No = implica que el estudiante cuenta con una
                              evaluación de AT Previa o por Remedio Provisional
                              vigente que sustenta el Referido de AT realizado
                              en el PEI. No se le coordinará cita para
                              evaluación. El referido de AT sera creado como
                              Avalúo o Validación según corresponda.
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="preEvaluationAnswer.isAtEvaluationNeeded == false"
                        id="hide"
                        class="form-group mt-4 mx-0 px-35"
                      >
                        <label
                          class="kselect-label"
                          for="exampleFormControlSelect1"
                        >
                          El estudiante fue evaluado recientemente por:
                        </label>
                        <select
                          id="recentlyevaluatedBy"
                          v-model="preEvaluationAnswer.recentlyEvaluatedBy"
                          class="form-control"
                          style="width: 100%"
                          name="recentlyevaluatedBy"
                          :error="
                            preEvaluationAnswer.recentlyEvaluatedBy == null
                          "
                        >
                          <option
                            v-for="option in recentlyEvaluatedOptions"
                            :key="option.id"
                            :value="option.id"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                        <span
                          v-show="
                            preEvaluationAnswer.isAtEvaluationNeeded == false &&
                              validationTriggered
                          "
                          class="invalid"
                        >
                          Debe seleccionar por quien se ha evaluado
                        </span>
                      </div>
                      <div
                        slot="footer"
                        style="float:right;margin-bottom:0px;margin-top:10px;"
                      >
                        <div class="group-1012 mr-2">
                          <button
                            class="btn btn-block btn-outline-danger bordercancel"
                            data-dismiss="modal"
                            @click="resetModal"
                          >
                            <i class="fas fa-times-circle mr-2" />
                            <span>Cancelar</span>
                          </button>
                        </div>
                        <div class="group-1012">
                          <button
                            class="btn btn-block btn-success btn-update"
                            @click="
                              isNew ? btnContinueClick() : showChangeAlert()
                            "
                          >
                            {{ isNew ? 'Continuar' : 'Guardar' }}
                          </button>
                        </div>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
              <div class="modal-footer" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import store from '@/store/index';
import CustomAlert from '@/mixin/alert.mixin';
import $ from 'jquery';

extend('mustBeDifferentThan', (value, args) => {
  if (args.length > 0) {
    if (value > 0) return true;
  }
  return 'Debe seleccionar por quien se ha evaluado';
});
export default {
  name: 'PreEvaluationAnswer',
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
    callBack: Boolean,
  },
  watch: {
    callBack() {
      this.ShowPreviusAnswer();
    },
  },
  computed: {
    isCheckSelected: function() {
      if (!this.$refs.check1) {
        return false;
      }

      return !this.$refs.check1.checked && !this.$refs.check2.checked;
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      peiId: store.getters.SelectedPei,
      isModalVisible: false,
      preEvaluationAnswer: {
        peiId: store.getters.SelectedPei,
        isAtEvaluationNeeded: null,
        recentlyEvaluatedBy: 0,
      },
      actionButton: {
        message: '',
        visible: false,
        peIStatusCode: 1,
      },
      recentlyEvaluatedOptions: {},
      initialRecentlyEvaluatedOptionsVal: 0,
      initialIsAtEvaluationNeededVal: true,
      validationTriggered: false,
      invalidSelection: false,
    };
  },
  methods: {
    ShowPreviusAnswer() {
      if (this.actionButton.message.length > 0) {
        this.actionButton.visible = true;

        store.commit('GetActionMessage', this.actionButton);
        this.$emit('showMessage');
      } else {
        this.getPreevaluationAnswer();
        this.getEvaluatedByValues();
        $('#exampleModal').modal('show');
      }
    },
    GetActionButton() {
      this.$ApiGet('/api/pei/getactionReferalAT?peiid=' + this.peiId).then(
        (res) => {
          this.actionButton = res.data;

          store.commit('GetActionMessage', this.actionButton);
          this.$emit('buttonaction', this.actionButton);
        }
      );
    },
    getPreevaluationAnswer() {
      this.$ApiGet('/api/pei/preanswerat?peiid=' + this.peiId).then((res) => {
        if (res.data != undefined) {
          this.preEvaluationAnswer = res.data;
          this.initialRecentlyEvaluatedOptionsVal =
            res.data.recentlyEvaluatedBy;
          this.initialIsAtEvaluationNeededVal = res.data.isAtEvaluationNeeded;
        } else {
          this.preEvaluationAnswer.peiId = this.peiId;
        }
      });
    },
    closeModal() {
      $('#exampleModal').modal('hide');
    },
    getEvaluatedByValues() {
      this.$ApiGet('api/atservice/getvaluesevaluatedby').then((res) => {
        this.recentlyEvaluatedOptions = res.data;
      });
    },
    backClicked() {},
    async btnContinueClick() {
      const formValid = await this.$refs.formValidator.validate();
      if (
        !formValid ||
        (this.preEvaluationAnswer.isAtEvaluationNeeded == false &&
          this.preEvaluationAnswer.recentlyEvaluatedBy == 0)
      ) {
        this.validationTriggered = true;
        return false;
      }

      if (this.preEvaluationAnswer.isAtEvaluationNeeded == true) {
        this.preEvaluationAnswer.recentlyEvaluatedBy = 0;
      }
      store.dispatch(
        'setSelectPreEvalAnswer',
        this.preEvaluationAnswer.isAtEvaluationNeeded
      );
      store.dispatch(
        'setSelectRecentlyEvalBy',
        this.preEvaluationAnswer.recentlyEvaluatedBy
      );
      this.Update();
    },
    Update() {
      this.$ApiPost(
        'api/atservice/setPreevaluationanswer',
        this.preEvaluationAnswer
      ).then(() => {
        this.closeModal();
        this.$router.push({ path: '/pei/at' });
      });
    },
    resetDll() {
      this.preEvaluationAnswer.recentlyEvaluatedBy = 0;
    },
    async showChangeAlert() {
      if (
        this.initialIsAtEvaluationNeededVal !=
        this.preEvaluationAnswer.isAtEvaluationNeeded
      ) {
        if (
          this.initialIsAtEvaluationNeededVal &&
          this.preEvaluationAnswer.recentlyEvaluatedBy == 1922
        ) {
          await this.showConfirmToShort();
        } else if (
          this.initialIsAtEvaluationNeededVal &&
          this.preEvaluationAnswer.recentlyEvaluatedBy != 1922
        ) {
          await this.btnContinueClick();
          CustomAlert.methods.ShowToast(
            'Proceso exitoso',
            'Cambio realizado satisfactoriamente',
            'success'
          );
        } else if (!this.initialIsAtEvaluationNeededVal) {
          await this.showConfirmToNomal();
        }
      } else {
        if (
          this.initialRecentlyEvaluatedOptionsVal !=
          this.preEvaluationAnswer.recentlyEvaluatedBy
        ) {
          if (this.initialRecentlyEvaluatedOptionsVal != 1922) {
            await this.showConfirmToShort();
          } else {
            await this.btnContinueClick();

            $('#exampleModal').modal('hide');

            CustomAlert.methods.ShowToast(
              'Proceso exitoso',
              'Cambio realizado satisfactoriamente',
              'success'
            );
          }
        } else {
          $('#exampleModal').modal('hide');

          CustomAlert.methods.ShowToast(
            'Alerta',
            'No se detectaron cambios',
            'warning'
          );
        }
      }
    },
    resetModal() {
      this.validationTriggered = false;
      this.preEvaluationAnswer.recentlyEvaluatedBy = this.initialRecentlyEvaluatedOptionsVal;
      this.preEvaluationAnswer.isAtEvaluationNeeded = this.initialIsAtEvaluationNeededVal;
    },
    async showConfirmToShort() {
      let alertResponse = false;
      let question =
        'Los datos documentados en las pestañas II-III, V y VI serán eliminados con esta acción. ¿Desea continuar?';

      $('#exampleModal').modal('hide');

      alertResponse = await CustomAlert.methods.ShowCancelModal(
        'Alerta',
        question,
        'Sí',
        'No'
      );

      if (alertResponse) {
        await this.removeInfo(false);

        CustomAlert.methods.ShowAlert(
          '',
          'Cambio realizado satisfactoriamente',
          'success',
          ''
        );
      }
    },
    async showConfirmToNomal() {
      let alertResponse = false;
      let question =
        'Los datos documentados sobre las Evaluaciones Recientes de Asistencia Tecnológica serán eliminados con esta acción. ¿Desea continuar?';

      $('#exampleModal').modal('hide');

      alertResponse = await CustomAlert.methods.ShowCancelModal(
        'Alerta',
        question,
        'Sí',
        'No'
      );

      if (alertResponse) {
        await this.removeInfo();

        CustomAlert.methods.ShowToast(
          'Proceso exitoso.',
          'Cambio realizado satisfactoriamente',
          'success'
        );
      }
    },
    removeInfo() {
      let self = this;
      let peiAtserviceId = store.getters.SelectedAt;

      let promise = new Promise((resolve) => {
        self
          .$ApiPost(
            'api/atservice/updatePreevaluationAnswer/' + peiAtserviceId,
            self.preEvaluationAnswer
          )
          .then((response) => {
            self.closeModal();
            self.$router.push({ path: '/pei/at/' });
            store.dispatch(
              'setSelectPreEvalAnswer',
              this.preEvaluationAnswer.isAtEvaluationNeeded
            );
            store.dispatch(
              'setSelectRecentlyEvalBy',
              this.preEvaluationAnswer.recentlyEvaluatedBy
            );

            resolve(response);
          })
          .catch((err) => {
            this.response = err;
          });
      });

      return promise;
    },
    ResetValidationStorage() {
      let tabValidations = {
        validation: false,
      };
      store.dispatch('setAtValidationTriggered', tabValidations);
    },
  },
  mounted() {
    this.GetActionButton();
    this.ResetValidationStorage();
  },
};
</script>

<style scoped>
.bg-error {
  background-color: #ffebeb !important;
  border: 1px solid #ff5b5c !important;
}
.modal-info {
  margin-left: -20px;
  margin-right: -21px;
}
.modal-header,
.modal-footer {
  display: none !important;
}

.align {
  position: relative;
  right: 3%;
  margin-top: 0.6%;
}

.rbcontaineryes {
  width: 50px;
  float: left;
  margin-right: 20px;
}
.rbcontainerno {
  float: left;
  width: 50px;
}
.group-1012 {
  width: 124px;
  height: 38px;
  float: left;
}
.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}
.modal-dialog {
  width: inherit !important;
}
.modal-container {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  padding: 5px 5px 5px 5px !important;
}
.btnadd {
  width: 119px;
  height: 38px;
  background: #2db782 0% 0% no-repeat padding-box;
  border-radius: 4px;
  text-align: center;
  font: 600 16px/29px Lato;
  letter-spacing: 0;
  color: #ffffff;
  float: right;
  margin-top: 8px;
  line-height: 38px;
  padding: 0px;
}

.tooltiptext {
  position: relative;
  visibility: hidden;
  width: 100%;
  background-color: #3f5b60;
  color: #fff;
  text-align: center;
  border-radius: 6px;

  margin-left: 5%;
  /* Position the tooltip */
  margin-top: 5%;
  z-index: 1;
}

.btncontainer:hover .tooltiptext {
  visibility: visible;
}

.modal-headerd {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: start;
  align-items: flex-start;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}

.modal-content {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}
h5.modal-title {
  width: 220px;
  text-align: left;
  font: Bold 18px/28px Lato;
  letter-spacing: 0;
  color: #11291b;
  margin-left: 0px !important;
  margin-bottom: 15px;
}

#modal-cambiar-form {
  margin-top: 20px;
}

.custom-footer {
  float: right;
  margin-bottom: 0px;
  margin-top: 10px;
}

.custom-cancel i {
  margin-right: 8px;
}

.custom-error i {
  float: left;
  margin-top: 4px;
  margin-right: 10px;
  color: #e85c5c;
}

.custom-error p {
  margin-top: 10px;
  color: #e85c5c;
  font-weight: normal;
}

.tag-badge span i {
  margin-top: 8px;
}

.tag-badge-title {
  float: right !important;
}
.modal[data-v-3a6cf9e4] {
  margin-top: 2rem !important;
}
.bordercancel {
  border: 1px solid !important;
}
.btn-update {
  background: #2db782 0% 0% no-repeat padding-box !important;
  border-radius: 4px !important;
  opacity: 1 !important;
}

.btn-update:hover {
  background: #207957 0% 0% no-repeat padding-box !important;
  border-radius: 4px !important;
  opacity: 1 !important;
}

span.tag-badge-title.at-badge {
  margin-right: 20px;
  font: Bold 19px/32px Lato;
}

.section-2-wrapper {
  background: transparent linear-gradient(0deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  margin-left: -21px;
  margin-right: -21px;
  padding-left: 21px;
  padding-right: 21px;
}

.section-2-sub-section-wrapper {
  padding-top: 20px;
}

.row.no-modal-margin {
  margin-left: -40px;
}

.no-padding {
  padding: 0 0 0 5px;
}

.dot.custom-dot {
  width: 30px;
  height: 30px;
}

.tag-badge.custom-tag-badge {
  height: 35px;
  margin-top: -5px;
  margin-bottom: -5px;
}
</style>

<style scoped src="@/assets/css/custom-style.css"></style>
<style scoped src="@/assets/css/all.css"></style>
